import { combineReducers } from 'redux'
import merchantIsAbleToTransact from './merchant-is-able-to-transact.store'
import creditLimit from './credit-limit.store'
import singlePlayer from './single-player.store'

export const rootReducer = combineReducers({
  merchantIsAbleToTransact,
  creditLimit,
  singlePlayer,
})
